(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.disciplinepartialday = skyward.disciplinepartialday || {};

        var init = function (selector)
        {
            var getDataForAjax = function (input)
            {
                if (input instanceof $ === false)
                {
                    input = $(input);
                }

                var calendarid = null;
                var dayrotation = null;
                var incidentoffensenameactiondetailid = null;
                var inputId = input.attr('id');

                if (inputId)
                {
                    if (inputId.indexOf('hiddencalendarid') > -1)
                    {
                        calendarid = input.val();
                    }
                    else if (inputId.indexOf('hiddendayrotation') > -1)
                    {
                        dayrotation = input.val();
                    }
                    else if (inputId.indexOf('hiddenincidentoffensenameactiondetailid') > -1)
                    {
                        incidentoffensenameactiondetailid = input.val();
                    }

                    if (dayrotation === null)
                    {
                        dayrotation = input.siblings('[id*="hiddendayrotation"]:eq(0)').val();
                    }
                    if (calendarid === null)
                    {
                        calendarid = input.siblings('[id*="hiddencalendarid"]:eq(0)').val();
                    }
                    if (incidentoffensenameactiondetailid === null)
                    {
                        incidentoffensenameactiondetailid = input.siblings('[id*="hiddenincidentoffensenameactiondetailid"]:eq(0)').val();
                    }
                }

                return {
                    calendarid: calendarid,
                    dayrotation: dayrotation,
                    incidentoffensenameactiondetailid: incidentoffensenameactiondetailid
                };
            };

            var onChangeCallback = function ()
            {
                var element = $(this);
                var postData = getDataForAjax(element);
                
                var viewpartContainer = element.parent();
                var table = viewpartContainer.children('table:eq(0)'); // Find existing table
                table.children().remove(); // remove existing table contents

                var myViewpartId = viewpartContainer.attr('id');

                // Nested id/name prefix/postfix from parent and grandparent repeaters
                var ancestorRepeaters = viewpartContainer.parents('tr.childrecordquickentryrow');
                var parentRepeaterId = ancestorRepeaters.eq(0).attr('id');
                var parentRepeaterIdPostfix = parentRepeaterId ? parentRepeaterId.substr(parentRepeaterId.lastIndexOf('-') + 1) : null;
                var nestedRepeaterIdPrefix = ancestorRepeaters.eq(1).attr('id');

                var loading = viewpartContainer.find('.disciplinepartialdayLoadingGif');
                loading.css('display', '');

                var message = viewpartContainer.children('label[id*="partialdaymessage"]:eq(0)');
                var portalForAjax = $("#PortalForAjax").val() || 'Administrative';

                if (myViewpartId)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + 'Discipline/IncidentOffenseNameActionDetail/UpdatePartialDayViewpart' + portalForAjax,
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            calendarid: postData.calendarid,
                            incidentoffensenameactiondetailid: postData.incidentoffensenameactiondetailid,
                            dayrotation: postData.dayrotation
                        },
                        success: function (data)
                        {
                            table.children().remove(); // remove existing table contents

                            if (data && data.viewparts)
                            {
                                var parsedHTML = $.parseHTML(data.viewparts);

                                updateIdsAndNamesInRepeater(parsedHTML, parentRepeaterIdPostfix, nestedRepeaterIdPrefix);

                                // Append all the newly rendered table's child content to the existing table
                                table.append($(parsedHTML).children());

                                // Hide the message label
                                message.css('display', 'none');

                                skyward.window.notifyDOMLoad(viewpartContainer.attr('id'));
                            }
                            else
                            {
                                // Show the message label
                                message.css('display', '');
                            }
                        },
                        complete: function ()
                        {
                            loading.css('display', 'none');
                        }
                    });
                }
            };

            var updateIdsAndNamesInRepeater = function (parsedHTML, parentRepeaterIdPostfix, nestedRepeaterIdPrefix)
            {
                // update ids and names if in a repeater
                if (parentRepeaterIdPostfix)
                {
                    $(parsedHTML).find('[id], [name], :input').each(function ()
                    {
                        var element = $(this);
                        var myId = element.attr('id');
                        var myName = element.attr('name');

                        if (myId)
                        {
                            myId = myId + '-add-' + parentRepeaterIdPostfix;
                        }

                        if (myName)
                        {
                            myName = myName + '-add-' + parentRepeaterIdPostfix;
                        }

                        if (myId || myName)
                        {
                            skyward.controls.changeId(element, myId, myName);
                        }
                    });
                }

                // update ids and names if in a nested repeater
                if (nestedRepeaterIdPrefix)
                {
                    $(parsedHTML).find('[id], [name], :input').each(function ()
                    {
                        var element = $(this);
                        var myId = element.attr('id');
                        var myName = element.attr('name');

                        if (myId)
                        {
                            myId = nestedRepeaterIdPrefix + '-' + myId;
                        }

                        if (myName)
                        {
                            myName = nestedRepeaterIdPrefix + '-' + myName;
                        }

                        if (myId || myName)
                        {
                            skyward.controls.changeId(element, myId, myName);
                        }
                    });
                }
            };

            var toggleMessageVisibility = function (partialDayViewpart, table)
            {
                var partialDayMessage = partialDayViewpart.children('label[id*="partialdaymessage"]:eq(0)');
                if (table.children().length === 0)
                {
                    partialDayMessage.css('display', '');
                }
                else
                {
                    partialDayMessage.css('display', 'none');
                }
            };

            $(selector + ' .disciplinepartialday').each(function ()
            {
                var partialDayViewpart = $(this);
                var validateControlFor = partialDayViewpart.attr('data-validate-control-for');
                var table = partialDayViewpart.children('table:eq(0)');
                if (validateControlFor && table.length > 0)
                {
                    table.attr('data-validate-control-for', validateControlFor);
                    partialDayViewpart.removeAttr('data-validate-control-for');
                }

                var hiddenInput = partialDayViewpart.children('input[id*="hiddencalendarid"],input[id*="hiddendayrotation"],input[id*="hiddenincidentoffensenameactiondetailid"]');
                hiddenInput.off('change').debounce('change', onChangeCallback);

                // Create Loading gif for when viewpart updates
                if (partialDayViewpart.find('.disciplinepartialdayLoadingGif').length === 0)
                {
                    var loading = skyward.window.getImage();
                    loading.removeClass('pageLoadingGif');
                    loading.addClass('disciplinepartialdayLoadingGif');
                    loading.css('display', 'none');
                    partialDayViewpart.append(loading);
                }
                
                toggleMessageVisibility(partialDayViewpart, table);
            });
        };

        skyward.disciplinepartialday.PartialDaySelectAll = function (checkbox)
        {
            var isChecked = checkbox.checked;
            var table = $(checkbox).closest('table');

            table.find('.checkbox:not(.SelectAllCheckbox)').each(function ()
            {
                skyward.controls.changeCheckBoxWithSelectAll($(this), isChecked);
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);